import { createContext, useContext, useEffect, useState } from "react";
import { useUserData } from "@/contexts/UserDataContext";
import { useAPI } from "@/contexts/APIContext";

const AffiliateContext = createContext(undefined);

const AffiliateProvider = ({ children }) => {
  const api = useAPI();
  const { currentUser } = useUserData();
  const [multiplier, setMultiplier] = useState(undefined);

  useEffect(() => {
    if (!currentUser) {
      return;
    }

    api
      .getUnprotected("affiliate/get-multiplier", currentUser)
      .then((res) => {
        const mul = res?.multiplier;
        if (mul && mul !== 1) {
          setMultiplier(mul);
        }
      })
      .catch(() => {
        // Do nothing
      });
  }, [currentUser]);

  const value = { multiplier };

  return <AffiliateContext.Provider value={value}>{children}</AffiliateContext.Provider>;
};

export default AffiliateProvider;

export const useAffiliateProvider = () => {
  const context = useContext(AffiliateContext);
  if (context === undefined) {
    throw new Error("Cannot call useAffiliateProvider outside AffiliateProvider");
  }
  return context;
};
